import { TAB_MENTIONS } from '../../../components/Notifications/helpers/constants';

/**
 * Remaining global unread after the server marked the whole tab as read.
 * Non-mentions tabs mark every unread event, so the badge goes to 0.
 * Mentions leftover is non-mentions; markedCount must include unloaded mentions
 * when the server reported how many it marked.
 */
export default function remainingUnreadAfterMarkAll(
  tab,
  notificationsUnreadCount = 0,
  markedCount = 0,
) {
  if (tab === TAB_MENTIONS) {
    return Math.max(0, notificationsUnreadCount - markedCount);
  }

  return 0;
}
